import { render, staticRenderFns } from "./legal-notices.vue?vue&type=template&id=37fe2d28"
import script from "./legal-notices.vue?vue&type=script&lang=js"
export * from "./legal-notices.vue?vue&type=script&lang=js"
import style0 from "./legal-notices.vue?vue&type=style&index=0&id=37fe2d28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports